import { AlertTriangle, X } from 'lucide-react';
import { useReseau } from '../lib/reseau.tsx';

/* Ce que la file n'a PAS pu porter.
 *
 * ── Pourquoi il faut le dire ────────────────────────────────────────────────
 *
 * Une écriture refusée par le serveur ne s'arrangera pas en la répétant, et la
 * garder bloquerait toutes les suivantes. La file la retire donc — mais un
 * retrait silencieux serait le pire des deux mondes : le joueur croirait sa
 * carte complète alors qu'il y manque un trou.
 *
 * Le cas est rare et anormal : un tour effacé depuis un autre téléphone, une
 * règle du serveur qu'un écran n'a pas vue. Rare ne veut pas dire caché.
 *
 * ── Pourquoi ce n'est pas une pastille ──────────────────────────────────────
 *
 * L'indicateur de réseau dit un état passager, et se lit d'un coup d'œil. Ceci
 * est un incident : il demande une lecture, et il ne disparaît que si on le
 * ferme. On ne remplace pas l'un par l'autre.
 */
export function EcrituresPerdues() {
    const { perdues, oublierPertes } = useReseau();
    if (perdues.length === 0) return null;

    return (
        <div role="alert"
            className="mx-3 mb-2 flex items-start gap-2 rounded-box border p-3 text-sm"
            style={{
                borderColor: 'var(--brique-bord)',
                background: 'var(--brique)',
                color: 'var(--brique-encre)',
            }}>
            <AlertTriangle size={18} className="mt-0.5 shrink-0" aria-hidden="true" />
            <div className="min-w-0 flex-1">
                <p className="font-semibold">
                    {perdues.length === 1
                        ? 'Une saisie n’a pas pu être enregistrée'
                        : `${perdues.length} saisies n’ont pas pu être enregistrées`}
                </p>
                <ul className="mt-1 space-y-0.5 text-xs">
                    {perdues.slice(0, 4).map((p, i) => (
                        <li key={`${p.quoi}-${i}`}>
                            <span className="font-semibold">{p.quoi}</span>
                            {' — '}{p.raison}
                        </li>
                    ))}
                    {perdues.length > 4 && <li>… et {perdues.length - 4} de plus.</li>}
                </ul>
            </div>
            <button type="button" onClick={oublierPertes}
                aria-label="Masquer"
                className="btn btn-ghost btn-xs btn-square shrink-0">
                <X size={16} />
            </button>
        </div>
    );
}
